<template>
    <v-tab-item :value="CEMS.value">
        <v-container>
            <top-image :tit="CEMS.text" bgImage="/images/sub/product/cems-bg.jpg" image="/images/sub/product/cems-img.png">
                <p class="page-text mb-6 mb-lg-20">
                    At KIE Systems, we understand the importance of monitoring emissions and air quality in order to maintain a healthy environment for all. That's why we have developed a
                    comprehensive solution for CEMS (Continuous Emission Monitoring Systems) and AQMS (Air Quality Monitoring Systems) that is both reliable and cost-effective.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Our solution is designed to help organizations of all sizes and industries to monitor and measure emissions and air quality in real-time. We utilize state-of-the-art technology
                    from trusted vendors to ensure that our clients receive the most accurate and reliable data possible.
                </p>
                <p class="page-text mb-6 mb-lg-20">
                    Our system includes a variety of monitoring equipment, such as analyzers, sampling systems and sensors that can detect and measure a wide range of pollutants and gases.
                </p>
                <p class="page-text">
                    In addition to monitoring and measuring emissions, our solution also includes a powerful data analysis and reporting system that allows our clients to easily access and interpret
                    the data we collect. This means that organizations can quickly identify areas where improvements need to be made and take action to reduce emissions and improve air quality.
                </p>
            </top-image>
        </v-container>
    </v-tab-item>
</template>

<script>
import TopImage from "@/components/dumb/top-image.vue";
import { Product_TABS } from "@/assets/variables";
const { CEMS } = Product_TABS;
export default {
    components: {
        TopImage,
    },
    data() {
        return {
            CEMS,
        };
    },
};
</script>

<style scoped></style>
